'use client';

import { Dialog, DialogContent, DialogPortal, DialogTitle } from '@repo/ui/dialog';
import { cn } from '@repo/utils/cn';
import React, { memo, useEffect, useState } from 'react';
import SidebarContent from '@/components/layout/sidebar-left/sidebar-content';
import { useAppStore } from '@/providers/AppStoreProvider';

/**
 * This component is used to display the more items menu dialog that opens from the bottom menu
 */
const MoreItemsMenuDialog = () => {
  const {
    isMoreMenuItemsDialogOpen,
    setIsMoreMenuItemsDialogOpen,
    accessToken: isAuthenticated,
    currentPathname,
  } = useAppStore((state) => ({
    isMoreMenuItemsDialogOpen: state.isMoreMenuItemsDialogOpen,
    setIsMoreMenuItemsDialogOpen: state.setIsMoreMenuItemsDialogOpen,
    accessToken: state.accessToken,
    currentPathname: state.currentPathname,
  }));

  useEffect(() => {
    if (currentPathname) {
      setIsMoreMenuItemsDialogOpen(false);
    }
  }, [currentPathname]);

  const handleOpenChange = (state: boolean) => setIsMoreMenuItemsDialogOpen(state);

  const [activeSidebarSection, setActiveSidebarSection] = useState<'CASINO' | 'SPORTS' | null>(null);

  const contentClassNameOverride =
    'max-h-[calc(100dvh-(var(--vt-header-nav-bar-height)+var(--vt-bottom-nav-bar-height)))] sm:max-h-[90%] sm:max-w-[90%] lg:max-w-[70%] sm:top-[50%] sm:translate-y-[-50%] top-[var(--vt-header-nav-bar-height)] translate-y-0';

  return (
    <Dialog
      modal={false}
      open={isMoreMenuItemsDialogOpen}
      onOpenChange={handleOpenChange}
    >
      <DialogPortal>
        <div className="w-full overflow-hidden">
          <DialogContent
            className={cn('flex h-full w-full flex-col gap-0 px-6 vt-surface-darker-bg', contentClassNameOverride)}
            portalOverlayClassName="!bg-transparent backdrop-blur-none"
          >
            <DialogTitle className="hidden" />
            <div className="hide-scrollbar flex h-full flex-col gap-2.5 overflow-y-auto overflow-x-hidden">
              <SidebarContent
                isBottomMenu
                sidebarOpen={isMoreMenuItemsDialogOpen}
                setActiveSidebarSection={setActiveSidebarSection}
                activeSidebarSection={activeSidebarSection}
                isAuthenticated={!!isAuthenticated}
              />
            </div>
          </DialogContent>
        </div>
      </DialogPortal>
    </Dialog>
  );
};

MoreItemsMenuDialog.displayName = 'MoreItemsMenuDialog';

export default memo(MoreItemsMenuDialog);
